// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1rTCN","upload":"Small_upload__2fDrA","imageWrap":"Small_imageWrap__33rIl","removeBtn":"Small_removeBtn__8nvuJ"};